module.exports = __webpack_public_path__ + "img/logo2.71043e6e.png";